const generos = [
  { id: 'H', label: 'Hombre' },
  { id: 'M', label: 'Mujer' },
  { id: 'O', label: 'Otros' },
];

export default generos;
